Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fastDeepEqual = require('fast-deep-equal');

var _fastDeepEqual2 = _interopRequireDefault(_fastDeepEqual);

var _warning = require('./helpers/warning');

var _warning2 = _interopRequireDefault(_warning);

var _renderComponent = require('./helpers/renderComponent');

var _renderComponent2 = _interopRequireDefault(_renderComponent);

var _isPromise = require('./helpers/isPromise');

var _isPromise2 = _interopRequireDefault(_isPromise);

var _setIn = require('./helpers/setIn');

var _setIn2 = _interopRequireDefault(_setIn);

var _getIn = require('./helpers/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _deepKeys = require('./helpers/deepKeys');

var _deepKeys2 = _interopRequireDefault(_deepKeys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// todo: make deepEqual a peer dep?


var createState = function createState(_ref) {
  var initialValues = _ref.initialValues;
  return {
    active: undefined,
    touched: {},
    values: initialValues,
    errors: {},
    validating: {},
    isSubmitting: false
  };
};

var Formera = function (_React$Component) {
  _inherits(Formera, _React$Component);

  function Formera(props) {
    _classCallCheck(this, Formera);

    var _this = _possibleConstructorReturn(this, (Formera.__proto__ || Object.getPrototypeOf(Formera)).call(this, props));

    _initialiseProps.call(_this);

    var render = props.render,
        children = props.children,
        component = props.component;


    (0, _warning2['default'])(render || typeof children === 'function' || component, 'Must specify either a render prop, a render function as children, or a component prop');

    _this.state = createState(props);
    _this.resets = 0;
    return _this;
  }

  _createClass(Formera, [{
    key: 'getChildContext',
    value: function () {
      function getChildContext() {
        return {
          formera: _extends({}, this.state, {
            registerField: this.registerField,
            unregisterField: this.unregisterField,

            handleFieldFocus: this.handleFieldFocus,
            handleFieldChange: this.handleFieldChange,
            handleFieldBlur: this.handleFieldBlur
          })
        };
      }

      return getChildContext;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        if (this.props.enableReinitialize && !(0, _fastDeepEqual2['default'])(nextProps.initialValues, this.props.initialValues)) {
          this.resetForm(nextProps);
        }
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps, nextState) {
        return !(0, _fastDeepEqual2['default'])(nextState, this.state);
      }

      return shouldComponentUpdate;
    }()

    /*
      I don't like react/sort-comp in this case, we should probably
      ignore that rule and sort manually
     */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            initialValues = _props.initialValues,
            onSubmit = _props.onSubmit,
            validateOnChange = _props.validateOnChange,
            validateOnBlur = _props.validateOnBlur,
            validate = _props.validate,
            props = _objectWithoutProperties(_props, ['initialValues', 'onSubmit', 'validateOnChange', 'validateOnBlur', 'validate']);

        var renderProps = _extends({}, this.state, {
          handleSubmit: this.handleSubmit,
          handleReset: this.handleReset
        }, props);

        // console.log('%cRendering Formera', 'color: #ff0000;');
        return (0, _renderComponent2['default'])(_extends({}, renderProps), 'Formera');
      }

      return render;
    }()
  }]);

  return Formera;
}(_react2['default'].Component);

Formera.childContextTypes = {
  formera: _propTypes2['default'].object
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setErrors = function () {
    var nextErrors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var promises = [];
    var errorKeys = (0, _deepKeys2['default'])(nextErrors);
    var errors = {};
    var validating = {};

    _this2.fields.filter(function (_ref2) {
      var name = _ref2.name;
      return errorKeys.indexOf(name) === -1;
    }).forEach(function (_ref3) {
      var setError = _ref3.setError;
      return setError(undefined, false);
    });

    errorKeys.forEach(function (path) {
      var error = (0, _getIn2['default'])(nextErrors, path);
      var isAsync = (0, _isPromise2['default'])(error);
      var fields = _this2.fields.filter(function (_ref4) {
        var name = _ref4.name;
        return name === path;
      });

      if (isAsync) {
        validating = (0, _setIn2['default'])(path, (0, _getIn2['default'])(_this2.state.validating, path, 0) + 1, validating);
        fields.forEach(function (_ref5) {
          var setError = _ref5.setError;
          return setError(undefined, 1);
        });
        var resets = _this2.resets;

        error.then(function (resolved) {
          if (_this2.resets !== resets) {
            return;
          }

          fields.forEach(function (_ref6) {
            var setError = _ref6.setError;
            return setError(resolved, -1);
          });

          _this2.setState(function (prevState) {
            var count = (0, _getIn2['default'])(prevState.validating, path) - 1;

            return {
              errors: (0, _setIn2['default'])(path, resolved, prevState.errors),
              validating: (0, _setIn2['default'])(path, count || undefined, prevState.validating)
            };
          });
        });

        promises.push(error);
      } else {
        errors = (0, _setIn2['default'])(path, error, errors);
        fields.forEach(function (_ref7) {
          var setError = _ref7.setError;
          return setError(error, 0);
        });
      }
    });

    _this2.setState({ errors: errors, validating: validating });

    return Promise.all(promises);
  };

  this.setSubmitting = function (isSubmitting) {
    _this2.setState({ isSubmitting: isSubmitting });
  };

  this.formeraActions = function () {
    return {
      setErrors: _this2.setErrors,
      setSubmitting: _this2.setSubmitting,
      resetForm: _this2.resetForm
    };
  };

  this.resetForm = function (props) {
    _this2.resets += 1;
    _this2.setState(createState(props || _this2.props), function () {
      _this2.fields.forEach(function (field) {
        return field.reset();
      });
    });
  };

  this.registerField = function (field) {
    _this2.fields.push(field);
  };

  this.unregisterField = function (field) {
    _this2.fields.splice(_this2.fields.indexOf(field), 1);
  };

  this.fields = [];

  this.runValidation = function (fieldName) {
    var validate = _this2.props.validate;


    if (!validate) {
      return Promise.resolve();
    }

    return _this2.setErrors(validate(fieldName, _extends({}, _this2.state)) || {});
  };

  this.handleReset = function () {
    if (_this2.props.onReset) {
      Promise.resolve(_this2.props.onReset(_this2.state, _this2.formeraActions())).then(_this2.resetForm);
    } else {
      _this2.resetForm();
    }
  };

  this.handleSubmit = function (event) {
    if (event && event.preventDefault) {
      event.preventDefault();
    }

    _this2.submitForm();
  };

  this.handleFieldFocus = function (_ref8) {
    var name = _ref8.name;

    _this2.fields.filter(function (field) {
      return field.name === name;
    }).forEach(function (_ref9) {
      var setActive = _ref9.setActive;
      return setActive(true);
    });

    _this2.setState({ active: name });
  };

  this.handleFieldChange = function (_ref10, value) {
    var name = _ref10.name;

    _this2.fields.filter(function (field) {
      return field.name === name;
    }).forEach(function (_ref11) {
      var setValue = _ref11.setValue;
      return setValue(value);
    });

    _this2.setState(function (_ref12) {
      var values = _ref12.values;
      return { values: (0, _setIn2['default'])(name, value, values) };
    }, function () {
      if (_this2.props.validateOnChange) {
        _this2.runValidation(name);
      }
    });
  };

  this.handleFieldBlur = function (_ref13) {
    var name = _ref13.name;

    _this2.fields.filter(function (field) {
      return field.name === name;
    }).forEach(function (_ref14) {
      var setActive = _ref14.setActive,
          setTouched = _ref14.setTouched;

      setActive(false);
      setTouched(true);
    });

    _this2.setState(function (_ref15) {
      var touched = _ref15.touched;
      return {
        active: undefined,
        touched: (0, _setIn2['default'])(name, true, touched)
      };
    }, function () {
      if (_this2.props.validateOnBlur) {
        _this2.runValidation(name);
      }
    });
  };

  this.submitForm = function () {
    var touched = {};
    _this2.fields.forEach(function (_ref16) {
      var name = _ref16.name,
          setTouched = _ref16.setTouched;

      setTouched(true);
      touched = (0, _setIn2['default'])(name, true, touched);
    });

    var reset = _this2.reset;


    _this2.setState({ touched: touched, isSubmitting: true }, function () {
      _this2.runValidation().then(function () {
        if (_this2.reset !== reset) {
          // Abort if we've had a reset
          return;
        }

        var isValid = Object.keys(_this2.state.errors).length === 0;

        if (isValid) {
          var submit = _this2.props.onSubmit(_this2.state, _this2.formeraActions());

          Promise.resolve(submit)['catch'](function () {}).then(function () {
            _this2.setSubmitting(false);
          });
        } else {
          _this2.setSubmitting(false);
        }
      });
    });
  };
};

Formera.propTypes = {
  render: _propTypes2['default'].func,
  children: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].node]),
  component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),

  // config props
  enableReinitialize: _propTypes2['default'].bool,
  initialValues: _propTypes2['default'].shape(),
  onSubmit: _propTypes2['default'].func.isRequired,
  onReset: _propTypes2['default'].func,
  validateOnBlur: _propTypes2['default'].bool,
  validateOnChange: _propTypes2['default'].bool,
  validate: _propTypes2['default'].func
};

Formera.defaultProps = {
  render: undefined,
  children: undefined,
  component: undefined,

  // config props
  enableReinitialize: false,
  initialValues: {},
  onReset: undefined,
  validateOnBlur: true,
  validateOnChange: true,
  validate: undefined
};

exports['default'] = Formera;


//////////////////
// WEBPACK FOOTER
// ./node_modules/formera/lib/Formera.js
// module id = 207
// module chunks = 0